import React from 'react'
import { Button } from 'react-weui'
import { browserHistory } from 'react-router'


class ScheduleErrorPage extends React.Component {
    componentDidMount () {
        document.title = '打卡活动已被删除'
    }
    render() {
        return (
            <div className="schedule-error-page wk-page">
                <div className="content text-center">
                    <div className="error-text">您访问的打卡活动已被删除</div>
                    <Button onClick={e => browserHistory.replace('/')}>回到首页</Button>
                </div>
                <a className="service text-center" href="/activity/servicepage/">客服指引</a>
            </div>
        )
    }
}

export default ScheduleErrorPage


// WEBPACK FOOTER //
// ./src/pages/schedule/ScheduleErrorPage.js